
/* approximate shape of the config
  {
    branches: [
      {
        branchId: 123,        // which branch this row is for
        quantity: 2,          // how many copies for this branch
        options: {            // EDI values for this branch
          "45": {"id": 12, code: "ABC123"},
          "46": {"id": 13, code: "XYZ"}
        },
        stockCategory: "7"    // Weave stock category ID — only present if it's a Weave basket
      },
      // ...one object per branch they had quantities for
    ]
  }
*/

export function getAuthorityIdFromCookie() {
      let authority = "";
      let name = "authorityId=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i <ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
              c = c.substring(1);
          }   
          if (c.indexOf(name) == 0) {
              authority = c.substring(name.length, c.length);
          }
      }
      //parse authority so it returns an integer number
      return parseInt(authority,10);
}

export function saveOrderingGridConfig(authorityId, config) {
    const key = `orderingGridDefaults_${authorityId}`;
    let jsonString = JSON.stringify(config);
    localStorage.setItem(key,jsonString);
}

export function getOrderingGridConfig(authorityId) {
    const key = `orderingGridDefaults_${authorityId}`;
    try {
        return JSON.parse(localStorage.getItem(key));
    } catch (error) {
        return null;
    }
}

export function deleteOrderingGridConfig(authorityId) {
    const key = `orderingGridDefaults_${authorityId}`;
    localStorage.removeItem(key);
}

export function lockOrderingGridMemoryFields(config) {
    // take the first non-empty value across branches for each field — if branches
    // disagree, we can only lock the modal's single "default" field to one value
    let stockCategory = null;
    const optionByEdi = {};
    config.branches.forEach(branch => {
        Object.entries(branch.options || {}).forEach(([ediId, option]) => {
            if (!optionByEdi[ediId]) {
                optionByEdi[ediId] = option;
            }
        });
        if (!stockCategory && branch.stockCategory) {
            stockCategory = branch.stockCategory;
        }
    });

    Object.entries(optionByEdi).forEach(([ediId, option]) => {
        const select = document.querySelector(`[name="basket[defaults][${ediId}]"]`);
        if (!select) {
            return;
        }
        select.value = option.id;
        select.disabled = true;
        select.insertAdjacentHTML('afterend', `<input type="hidden" class="orderingGridMemoryLockInput" name="basket[defaults][${ediId}]" value="${option.id}">`);
    });

    if (stockCategory) {
        const select = document.querySelector('[name="basket[defaultStockCategory]"]');
        if (select) {
            select.value = stockCategory;
            select.disabled = true;
            select.insertAdjacentHTML('afterend', `<input type="hidden" class="orderingGridMemoryLockInput" name="basket[defaultStockCategory]" value="${stockCategory}">`);
        }
    }
}

export function unlockOrderingGridMemoryFields() {
    document.querySelectorAll('.orderingGridMemoryLockInput').forEach(el => el.remove());
    document.querySelectorAll('[name^="basket[defaults]"], [name="basket[defaultStockCategory]"]').forEach(el => {
        el.disabled = false;
    });
}

export function initOrderingGridMemoryUI(orderingGridMemoryEnabled) {
    if (!orderingGridMemoryEnabled) {
        return;
    }
    const authorityId = getAuthorityIdFromCookie();
    const config = getOrderingGridConfig(authorityId);
    const notice = document.getElementById('orderingGridMemoryNotice');
    if (!config || !notice) {
        return;
    }

    notice.classList.remove('is-hidden');
    lockOrderingGridMemoryFields(config);
    document.getElementById('orderingGridMemoryCancel').addEventListener('click', e => {
        e.preventDefault();
        deleteOrderingGridConfig(authorityId);
        unlockOrderingGridMemoryFields();
        notice.classList.add('is-hidden');
    });
}
